export function FeedbackSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/feedback.svg'"></ng-include>`
    }
}